const reduxConfig = {
  appName: '@@tmrtracker',
};

export default reduxConfig;
